import Pagination from './pagination';
import Slider from '../components/slider';

export default class QuestionsBox {

  constructor(container) {
    this.container = container;
    this.sliderContainer = $(container).children('.o-slider').first()[0];
    this.slider = null;
    this.questions = $(this).find('.c-questions-box__question');
    this.paginationContainer = $(this).find('#questions-pagination');
    
    this.init();
  }

  init() {
    var that = this;

    // Init question and question form slider
    this.slider = new Slider(this.sliderContainer, {
      slidesPerView: 2,
      allowTouchMove: false,
      uniqueNavElements: false,

      breakpoints: {
        767: {
          slidesPerView: 1,
          allowTouchMove: true,
        },
      },
    });

    this.addEventlisteners();

    this.pagination = new Pagination({
      container : that.paginationContainer,
      page : 1,
      postType : 'question',
      postsPerPage : ajax_args.questions_per_page,
      beforeLoad : function() {
        that.setLoading(true);
      },
      onUpdate : function(response) {
        $('#questions-list').html(response['questions']);
        $('#answers-list').html(response['answers']);
        that.addEventlisteners();
        that.setLoading(false);
        that.slider.update();
      },
      onPageChange : function() {
        if (window.innerWidth <= 600) {
          that.scrollToTop();
        }
      },
    });
  }

  addEventlisteners() {
    // Questions box answer item toggle
    var that = this;
    this.questions = this.container.find('.c-questions-box__question');
    this.questions.click(function() {
      if ($(this).hasClass('c-questions-box__question--active') == false) {
        var id = $(this).attr('data-id');
        $('.c-questions-box__question--active').removeClass('c-questions-box__question--active');
        $('.c-questions-box__answer--active').removeClass('c-questions-box__answer--active');
        $('.c-questions-box__answer[data-id="' + id +'"]').addClass('c-questions-box__answer--active');
        $(this).addClass('c-questions-box__question--active');
      }

      that.slider.next();
      
      if (window.innerWidth <= 600) {
        that.scrollToTop();
      }
    });
  }

  loadFilteredQuestions(taxonomies) {
    this.slider.slideTo(0);
    this.setLoading(true);
    this.pagination.getPosts(1, taxonomies);
  }

  setLoading(active) {
    let loadingClass = 'c-questions-box--loading';
    if (active) {
      $(this.container).addClass(loadingClass);
    } else {
      $(this.container).removeClass(loadingClass);
    }
  }

  scrollToTop() {
    let container = $('#c-questions-box__scroll-marker')[0];
    if (container) {
      container.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/questions-box.js